import {
  listWards,
  createWard,
  updateWard,
  deleteWard,
  getWard as getWardService,
} from "app/services/settings.service";
import {
  WARD_REQUEST,
  WARD_FAILURE,
  FETCH_WARDS_SUCCESS,
  CREATE_WARD_SUCCESS,
  DELETE_WARD_SUCCESS,
  UPDATE_WARD_SUCCESS,
  GET_WARD_SUCCESS,
} from "./types";

export const wardRequest = () => ({
  type: WARD_REQUEST,
});

export const wardFailure = (error) => ({
  type: WARD_FAILURE,
  payload: error,
});

export const fetchWardsSuccess = (wards) => ({
  type: FETCH_WARDS_SUCCESS,
  payload: wards,
});

export const createWardSuccess = (ward) => ({
  type: CREATE_WARD_SUCCESS,
  payload: ward,
});

export const updateWardSuccess = (ward) => ({
  type: UPDATE_WARD_SUCCESS,
  payload: ward,
});

export const deleteWardSuccess = (id) => ({
  type: DELETE_WARD_SUCCESS,
  payload: id,
});

export const getWardSuccess = (ward) => ({
  type: GET_WARD_SUCCESS,
  payload: ward,
});

export const fetchWards = () => {
  return async (dispatch) => {
    dispatch(wardRequest());
    try {
      const data = await listWards();
      dispatch(fetchWardsSuccess(data));
      return data;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi tải phường";
      dispatch(wardFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * @param {Object} wardData - { name, slug, description }
 */
export const addWard = (wardData) => {
  return async (dispatch) => {
    dispatch(wardRequest());
    try {
      const data = await createWard({ data: wardData });
      dispatch(createWardSuccess(data));
      return data;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi tạo phường";
      dispatch(wardFailure(messageText));
      throw new Error(messageText);
    }
  };
};

/**
 * @param {string} id - ID của danh mục
 * @param {Object} categoryData - { name, slug, description }
 */
export const editWard = (id, wardData) => {
  return async (dispatch) => {
    dispatch(wardRequest());
    try {
      const data = await updateWard({ id, data: wardData });
      dispatch(updateWardSuccess(data));
      return data;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi cập nhật phường";
      dispatch(wardFailure(messageText));
      throw new Error(messageText);
    }
  };
};

export const fetchWard = () => {
  return async (dispatch) => {
    dispatch(wardRequest());
    try {
      const data = await getWardService();
      dispatch(getWardSuccess(data));
      return data;
    } catch (error) {
      const message =
        error?.response?.data?.message || "Lỗi khi lấy thông tin phường";
      dispatch(wardFailure(message));
      return null;
    }
  };
};

/**
 * @param {string} id - ID của phường cần xóa
 */
export const removeWard = (id) => {
  return async (dispatch) => {
    dispatch(wardRequest());
    try {
      await deleteWard({ id });
      dispatch(deleteWardSuccess(id));
      return true;
    } catch (error) {
      const resData = error?.response?.data;
      const messageText =
        resData?.error || resData?.message || "Lỗi khi xóa phường";
      dispatch(wardFailure(messageText));
      throw new Error(messageText);
    }
  };
};
